import { Grid, makeStyles, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import { InfoBox } from "../../../../components/boxes/InfoBox";
import { BarChart } from "../../../../components/charts/BarChart";
import { LocationIcon } from "../../../../components/map/LocationIcon";
import { COLORS } from "../../../../theme/colors";
import { Box } from "../Box";
import { GroupButton } from "../GroupButton";
import { Header } from "../Header";
import { consumptionDataForExpectedGrowth } from "../sample";

const useStyles = makeStyles((theme) => ({
  chartTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(3.5),
  },
  optionalSpace: {
    fontWeight: 600,
    marginTop: theme.spacing(3.5),
  },
  subTitle: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  sqft: {
    color: COLORS.darks[0][50],
  },
}));

export const ExpectedGrowth = ({ building, onClose }) => {
  const classes = useStyles();
  const { user } = useSelector((state) => state.auth);

  return (
    <Box>
      <Header title="Expected Growth" building={building} onClose={onClose} />

      <InfoBox color="#E7FCDC">
        <Typography variant="h4">
          Power consumption increased throughout the last 6months
        </Typography>
      </InfoBox>

      <Typography className={classes.chartTitle}>
        Consumption over 2021
      </Typography>
      <BarChart
        height={120}
        barSize={10}
        chartData={consumptionDataForExpectedGrowth}
      />
      <Typography className={classes.optionalSpace} variant="h4">
        Optional spaces nearby
      </Typography>
      <Grid container alignItems="center">
        <LocationIcon width={22} color={COLORS.red} />
        <Typography className={classes.subTitle} variant="h4">
          Landmark Office Space, Canary Wharf
        </Typography>
        <Typography className={classes.sqft}>3,200{user?.unit_system}</Typography>
      </Grid>
      <Typography style={{ marginLeft: 30, color: COLORS.red }}>
        Vacant property.
      </Typography>

      <GroupButton
        buttons={[
          { text: "SHARE" },
          { text: "VIEW REPORT" },
          { text: "EXPORT SAME TYPE ALERTS" },
        ]}
      />
    </Box>
  );
};
